import React from 'react';
import { inject, observer } from 'mobx-react';

const PwaInstallBanner = inject('rootstore', 'langstore')(observer(
    function PwaInstallBanner({ rootstore, langstore, offset = 0 }) {

        if (!rootstore.pwaInstallBannerVisible) return null;

        const positionStyle = offset > 0
            ? { top: `${1.5 + offset * 1}rem`, right: `${1.5 + offset * 1}rem`, zIndex: 1052 - offset }
            : undefined;

        const closeBtn = (
            <button
                className="pwa_banner__btn-never"
                onClick={() => rootstore.pwaInstallClose()}
                title={langstore.t('pwa_install_later', 'Non ora')}
            >
                <i className="fas fa-times" />
            </button>
        );

        const installNeverBtn = (
          <button
            className="btn pwa_banner__btn-later"
            onClick={() => rootstore.pwaInstallNever()}
          >
            {langstore.t('pwa_install_never', 'Non chiedermelo più')}
          </button>
        );

        const installTriggerBtn = (
          <button
            className="ts_button2 pwa_banner__btn-install"
            onClick={() => rootstore.pwaInstallTrigger()}
          >
            {langstore.t('pwa_install_confirm', 'Installa')}
          </button>
        );

        return (
            <div className="pwa_banner pwa_banner--stacked" style={positionStyle}>
                {closeBtn}
                <div className="pwa_banner__icon">
                    <i className="fas fa-download" />
                </div>
                <div className="pwa_banner__body">
                    <p className="pwa_banner__title">
                        {langstore.t('pwa_install_title', 'Installa l\'app')}
                    </p>
                    <p className="pwa_banner__subtitle">
                        {rootstore.pwaInstallIsIos ? (
                            langstore.t(
                              'pwa_install_ios_instructions',
                              'Tocca il pulsante "Condividi" del browser, poi seleziona "Aggiungi a schermata Home"'
                            )
                        ) : rootstore.pwaInstallIsSafariMac ? (
                            langstore.t(
                              'pwa_install_safari_mac_instructions',
                              'Clicca sul pulsante "+" nella barra degli indirizzi oppure vai su File → Aggiungi al Dock'
                            )
                        ) : (
                            langstore.t(
                              'pwa_install_subtitle',
                              'Accedi più velocemente dalla schermata home del tuo dispositivo.'
                            )
                        )}
                    </p>
                </div>

                <div className="pwa_banner__actions">
                    {!rootstore.pwaInstallIsIos && !rootstore.pwaInstallIsSafariMac && installTriggerBtn}
                    {installNeverBtn}
                </div>
            </div>
        );
    }
));

export default PwaInstallBanner;
